import { RouterProvider } from 'react-router-dom';
import { router } from './app/router';
import { useDateKeyWatcher } from './app/useDateKeyWatcher';
import { useEngineRecovery } from './app/useEngineRecovery';

export function App() {
  useDateKeyWatcher();
  useEngineRecovery();
  return <RouterProvider router={router} />;
}
